import { render, staticRenderFns } from "./CategoriesEdit.vue?vue&type=template&id=3f25b4fe&scoped=true"
import script from "./CategoriesEdit.vue?vue&type=script&lang=js"
export * from "./CategoriesEdit.vue?vue&type=script&lang=js"
import style0 from "./CategoriesEdit.vue?vue&type=style&index=0&id=3f25b4fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f25b4fe",
  null
  
)

export default component.exports